var map = {
	"./MikeandRoy.jpg": 9557,
	"./community.png": 5949,
	"./event.jpg": 9054,
	"./hotel.png": 3472,
	"./leadership.jpg": 5293,
	"./mv.png": 7113,
	"./rotc1.jpg": 1705,
	"./rotc2.jpg": 2110,
	"./roypaco.jpg": 4619
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6666;